import { useTranslation } from 'next-i18next';

import { Flex, FlexProps, Text, useBreakpointValue } from '@chakra-ui/react';

import { Image } from '@nocowanie/common-ui/components/atoms/image';

import { AppPromotionLink } from '@app/components/atoms/app-promotion-link';
import { APP_PROMOTION_ASSETS } from '@app/consts/app-promotion.consts';
import { AppPromotionPlatform } from '@app/models/app-promotion-platform.model';
import * as commonUiStateSlice from '@app/state/slices/common-ui-state.slice';
import { useAppSelector } from '@app/state/state';

export const AppPromotionLinks = (props: FlexProps) => {
    const { t } = useTranslation('common', { keyPrefix: 'appPromotion' });

    const isMobileBrowser = useAppSelector(commonUiStateSlice.selectors.selectIsMobileVersion);

    const isMobileRes = useBreakpointValue(
        {
            base: true,
            md: false,
        },
        {
            fallback: isMobileBrowser ? 'base' : 'md',
        },
    );

    return (
        <Flex direction={'column'} gap={3} {...props}>
            <Text
                fontSize={{
                    md: 'lg',
                }}
            >
                {isMobileRes ? t('ctaMobile') : t('ctaDesktop')}
            </Text>
            <Flex gap={5} align="center">
                {!isMobileRes ? (
                    <Image
                        src={APP_PROMOTION_ASSETS.qrCode}
                        alt={t('scanQRCode')}
                        htmlWidth="120px"
                        htmlHeight="120px"
                        borderRadius="md"
                    />
                ) : null}

                <Flex direction={isMobileRes ? 'row' : 'column'} gap={isMobileRes ? 2 : 6}>
                    <AppPromotionLink platform={AppPromotionPlatform.GooglePlay} />
                    <AppPromotionLink platform={AppPromotionPlatform.AppStore} />
                </Flex>
            </Flex>
        </Flex>
    );
};
